import React from "react";
import AddAndEditUser from "../../../components/AddAndEditUser/AddAndEditUser";

function EditUser() {
  return <AddAndEditUser type="edit" />;
}

export default EditUser;
